<template>
	<div class="user-root">
		<ResidentialUserNavbar />
		<router-view v-if="isLoggedIn" class="navbar-page" />
	</div>
</template>

<style scoped>
.user-root {
	height: 100%;
}
</style>

<script>
import { eventBus, EventBusEvents } from "@/eventBus"
import ResidentialUserNavbar from "@/components/navbars/ResidentialUserNavbar.vue"

export default {
	name: "UserRoot",
	components: {
		ResidentialUserNavbar
	},
	computed: {
		isLoggedIn() {
			return this.$store.getters.isLoggedIn
		}
	},
	mounted: function() {
		if (!this.isLoggedIn) {
			eventBus.emit(EventBusEvents.OPEN_VERIFY_FLOW, {
				required: true
			})
		}
	}
}
</script>
